// src/contexts/FeedContext.tsx
import React, { createContext, useContext, useState, ReactNode, useEffect } from "react";
import { useAuth } from "../global-components/src";
import { Post } from "../types";
import { getAppVersion, isNewApp } from "../utils/platform";

interface FeedContextData {
  posts: Post[];
  setPosts: React.Dispatch<React.SetStateAction<Post[]>>;
  feedType: "not_displayed" | "feed" | "following";
  setFeedType: React.Dispatch<React.SetStateAction<"not_displayed" | "feed" | "following">>;
  end: boolean;
  setEnd: React.Dispatch<React.SetStateAction<boolean>>;
  page: number;
  setPage: React.Dispatch<React.SetStateAction<number>>;
  cursor: number | null;
  setCursor: React.Dispatch<React.SetStateAction<number | null>>;
  anchorId: number | null;
  setAnchorId: React.Dispatch<React.SetStateAction<number | null>>;
}

const FeedContext = createContext<FeedContextData | undefined>(undefined);

export const FeedProvider = ({ children }: { children: ReactNode }) => {
  const [posts, setPosts] = useState<Post[]>([]);
  const [feedType, setFeedType] = useState<"not_displayed" | "feed" | "following">("not_displayed");
  const [anchorId, setAnchorId] = useState<number | null>(null);
  const [end, setEnd] = useState(false);
  const [page, setPage] = useState(0);
  const [cursor, setCursor] = useState<number | null>(null);
  const [buildVersion, setIsDarkMode] = useState(getAppVersion());

  useEffect(() => {
      const root = document.documentElement;
      if(isNewApp()){
        root.classList.add('space-new-app');
      }
    }, [buildVersion]);

  return (
    <FeedContext.Provider
      value={{ posts, setPosts, feedType, setFeedType, end, setEnd, page, setPage, cursor, setCursor, anchorId, setAnchorId }}
    >
      {children}
    </FeedContext.Provider>
  );
};

export const useFeed = (): FeedContextData => {
  const context = useContext(FeedContext);
  if (!context) {
    throw new Error("useFeed deve ser usado dentro do FeedProvider");
  }
  return context;
};
